import React from "react";
import { Box, Paper, useTheme } from "@mui/material";

export type ListSurfaceProps = {
  toolbar?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  "aria-label"?: string;
  fill?: boolean;
};

export function ListSurface({ toolbar, footer, children, "aria-label": ariaLabel, fill = true }: ListSurfaceProps) {
  const theme = useTheme();

  return (
    <Paper
      component="section"
      role="region"
      aria-label={ariaLabel}
      elevation={0}
      sx={{
        display: "flex",
        flexDirection: "column",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        overflow: "hidden",
        bgcolor: theme.palette.background.paper,
        ...(fill && {
          height: "100%",
          minHeight: 0,
          flex: 1,
        }),
      }}
    >
      {toolbar != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderBottom: `1px solid ${theme.palette.divider}`,
          }}
        >
          {toolbar}
        </Box>
      ) : null}

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: "auto",
        }}
      >
        {children}
      </Box>

      {footer != null ? (
        <Box
          sx={{
            flexShrink: 0,
            borderTop: `1px solid ${theme.palette.divider}`,
          }}
        >
          {footer}
        </Box>
      ) : null}
    </Paper>
  );
}
